import {Howl} from "howler";

const RINGTONE = new Howl({
  src: [""],
  loop: true,
});

export function playRingtone(): void {
  RINGTONE.play();
}

export function stopRingtone(): void {
  RINGTONE.stop();
}